import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import getIn from 'immutable-less/transmute/getIn';
import { ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
/**
 * Query to get individual sets of data sources by prefix.
 */
export const GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME = 'dataSourceByPrefix';
export const GET_DATA_SOURCE_BY_PREFIX = registerQuery({
  fieldName: GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME,
  args: ['flowId', 'flowObjectTypeId', 'prefix', 'query'],
  fetcher: ({
    flowId,
    flowObjectTypeId: objectTypeId,
    prefix,
    query
  }) => {
    if (prefix === ENROLLED_OBJECT && Number.isNaN(flowId)) {
      return http.post('automationplatform/v1/data-sources/enrolled-object', {
        data: {
          enrolledType: {
            type: 'CRM_OBJECT',
            objectTypeId
          }
        }
      });
    } else {
      return http.get(`automationplatform/v1/data-sources/flows/${flowId}/${prefix}`, {
        query
      });
    }
  }
});
export const GET_DATA_SOURCES_BY_PREFIX_FIELD_NAME = 'getDataSources';
export const GET_DATA_SOURCES_BY_PREFIX = registerQuery({
  fieldName: GET_DATA_SOURCES_BY_PREFIX_FIELD_NAME,
  args: ['flowId', 'flowObjectTypeId', 'prefixReqs'],
  fetcher({
    flowId,
    flowObjectTypeId,
    prefixReqs
  }, {
    client
  }) {
    return Promise.all(prefixReqs.map(prefixReq => {
      const {
        prefix,
        options
      } = prefixReq;
      const {
        query = {}
      } = options || {};
      return client.query({
        query: GET_DATA_SOURCE_BY_PREFIX,
        variables: {
          flowId,
          flowObjectTypeId,
          prefix,
          query
        }
      });
    })).then(queryResponseArray => {
      const data = queryResponseArray.reduce((acc, id, index) => {
        const prefix = Object.keys(getIn([index, 'data', 'dataSourceByPrefix', 'dataSources'], queryResponseArray))[0];
        const dataSourceDefinition = getIn([index, 'data', 'dataSourceByPrefix', 'dataSources', prefix, 'dataSourceDefinition'], queryResponseArray);
        const dataSourceProperties = getIn([index, 'data', 'dataSourceByPrefix', 'dataSources', prefix, 'dataSourceProperties'], queryResponseArray);
        acc.set(prefix, {
          dataSourceDefinition,
          dataSourceProperties
        });
        return acc;
      }, new Map());
      return data;
    });
  }
});